var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{key:`${_vm.item} + ${_vm.index}`,staticClass:"p-2 font-weight-600 heading--text"},[_c('span',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.item))]),_c('copy-text-button',{attrs:{"text":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }